var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "33.601555mm",
    viewBox: "0 0 24.001027 33.601554",
    width: "24.001028mm",
    id: "svg34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata40"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M -5.3500755,-0.5490035 H 29.349591 V 34.150663 H -5.3500755 Z",
    id: "path2",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.11871969
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4000185,0,0,0.4000185,-3.3201535e-6,0)",
    id: "g32",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.869,0 48.563,5.5746 10.387,27.5286 0.693,21.9539 Z",
    id: "path4",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.954,6.7451 -37.936,21.806 -0.0013,11.032 37.936,-21.806 z",
    id: "path6",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.698,28.276 11.097,41.267 11.0958,52.3 33.6968,39.309 Z",
    id: "path8",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.035,45.717 -13.99,8.0421 -0.0013,11.033 13.991,-8.0421 z",
    id: "path10",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0.0037583,23.017 9.751,5.6047 -0.00375,11.035 -9.751,-5.6046 z",
    id: "path12",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0.096543,35.657 9.6327,5.5367 -0.00376,11.035 -9.6327,-5.5366 z",
    id: "path14",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0.092298,48.221 9.6359,5.5386 -0.00401,11.763 -9.6359,-5.5386 z",
    id: "path16",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.564,84 11.87,78.4254 49.613,56.7214 59.3069,62.296 Z",
    id: "path18",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.102,77.471 48.981,55.698 48.9822,44.666 11.1032,66.439 Z",
    id: "path20",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.3,55.974 48.901,42.983 48.9023,31.95 26.3013,44.941 Z",
    id: "path22",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.964,38.532 13.99,-8.0421 0.0012,-11.033 -13.99,8.0421 z",
    id: "path24",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 59.996,61.306 -9.7509,-5.6046 0.0037,-11.035 9.751,5.6046 z",
    id: "path26",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 59.904,48.595 -9.6327,-5.5367 0.0037,-11.035 9.6327,5.5366 z",
    id: "path28",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 59.908,36.031 -9.636,-5.5386 0.0039,-11.552 9.636,5.5385 z",
    id: "path30",
    style: {
      fill: "#0051cd",
      fillOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormik);
export default __webpack_public_path__ + "static/media/Formik.1b4e0840be4c64f5fc4e4d850fb4bd49.svg";
export { ForwardRef as ReactComponent };